import { render, staticRenderFns } from "./WorkflowTestAuditTrailHistory.vue?vue&type=template&id=21469717"
import script from "./WorkflowTestAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowTestAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports